@mixin input-position {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
}
$input-size: 24px;
$checked-size: 12px;

.smart-radio {
  $this: &;

  display: flex;
  align-items: center;
  position: relative;

  padding-left: $input-size;
  height: calc($input-size + 2px);

  & > input {
    visibility: hidden;
    @include input-position;
  }

  &::before {
    content: "";
    @include input-position;  

    width: $input-size;
    height: $input-size;
    border-width: 1px;
    border-style: solid;
    border-radius: 100%;
  }
  
  &::after {
    content: "";
    position: absolute;

    top: calc(($checked-size / 2) + 1px);
    left: calc(($checked-size / 2) + 1px);
    width: $checked-size;
    height: $checked-size;

    background-color: $color-base-brand-black;
    border-radius: 100%;
    
    visibility: hidden;
  }
  smart-text {
    margin-left: $size-space-sm;
  }
  &--checked {
    &::after {
      visibility: visible;
    }
  }
  &--primary {
    &::before {
      border-color: $color-base-gray-gray-5;
      background-color: $color-base-brand-white;
    }
  
    &#{$this}--disabled {
      &::before {
        border-color: $color-base-gray-gray-3;
        background-color: $color-base-gray-gray-1;
      }
  
      smart-text {
        color: $color-typography-typo-48 !important;
      }
    }
  }

  &--error {
    &::before {
      border-color: $color-action-destrutive;
    }
  }
}
:host(.hydrated) {
  .smart-radio {
    &--checked {
      &::after {
        visibility: visible;
      }
    }
  }
}



